export function formatCurrency(value) {
  if (value == null) return ''
  return parseFloat(value / 100).toLocaleString('en-PH', {
    style: 'currency',
    currency: 'PHP'
  })
}

export function getCurrencyFieldValue(value) {
  let amount = value
  if (typeof amount === 'string') {
    amount = Number(value.replace(/[^0-9.-]+/g, ''))
  }
  return amount * 100
}
